import type { LegalTextSection } from './legalContent';

export const TERMS_SECTIONS_AR: LegalTextSection[] = [
  {
    title: 'المادة 1 (الغرض)',
    paragraphs: [
      'تهدف هذه الشروط إلى تحديد شروط وإجراءات استخدام موقع Medicrew الإلكتروني، وتطبيق الهاتف المحمول، ومحاكاة التعليم الطبي القائمة على الواقع الافتراضي، والمحتوى التعليمي، وإدارة الصفوف والمناهج، وإدارة نتائج التدريب، وخدمات الطلب والدفع، والخدمات الإضافية ذات الصلة (ويشار إليها مجتمعة باسم "الخدمة") التي تديرها شركة NEWBASE Co., Ltd. (ويشار إليها باسم "الشركة")، وكذلك حقوق والتزامات ومسؤوليات الشركة والأعضاء.',
    ],
  },
  {
    title: 'المادة 2 (التعريفات)',
    items: [
      '"العضو" يعني الشخص الذي يوافق على هذه الشروط ويستخدم الخدمة عن طريق إنشاء حساب وفق الإجراءات التي تحددها الشركة أو من خلال دعوة من مؤسسة.',
      '"العضو المؤسسي" يعني شركة أو منظمة، مثل مستشفى أو مدرسة أو مؤسسة تعليمية أو شركة، تقدم الخدمة لأعضائها من خلال اتفاقية خدمة أو طلب.',
      '"المسؤول" أو "الماستر" يعني عضوا مخولا من العضو المؤسسي لإدارة الأعضاء التابعين، والصفوف، والتراخيص، والمحتوى، ونتائج التدريب، وما شابه ذلك.',
      '"المتعلم" يعني عضوا يستخدم ميزات تعليمية مثل المشاركة في الصفوف، والتدريب بالمحاكاة، وعرض المحتوى، ومراجعة نتائج التدريب.',
      '"المحتوى" يعني محاكاة الواقع الافتراضي والهاتف المحمول، والسيناريوهات، والصور، والفيديو، والصوت، والأسئلة، ومعايير التقييم، والمستندات، والبيانات، وغيرها من المواد الرقمية التي تقدمها الشركة أو تكون متاحة داخل الخدمة.',
      '"الخدمة المدفوعة" تعني أي خدمة تقدمها الشركة مقابل رسوم، بما في ذلك الاشتراكات، والتراخيص، والصفوف المفتوحة، وصفوف المؤسسات، والمعدات، أو الخدمات الإضافية.',
    ],
  },
  {
    title: 'المادة 3 (نشر الشروط وتعديلها)',
    items: [
      'تنشر الشركة هذه الشروط على شاشة الخدمة أو شاشة مرتبطة بها حتى يتمكن الأعضاء من مراجعتها بسهولة.',
      'يجوز للشركة تعديل هذه الشروط في حدود ما لا يخالف القوانين المعمول بها.',
      'إذا عدلت الشركة هذه الشروط، فستعلن تاريخ النفاذ والأسباب الرئيسية للتعديل قبل تاريخ النفاذ بسبعة أيام. أما التغييرات غير الملائمة للأعضاء أو الجوهرية فسيتم الإعلان عنها قبل ثلاثين يوما من تاريخ النفاذ أو إخطار الأعضاء بها بوسائل معقولة مثل البريد الإلكتروني أو إشعارات الخدمة.',
      'إذا استمر العضو في استخدام الخدمة بعد تاريخ نفاذ الشروط المعدلة، فيعد العضو موافقا على الشروط المعدلة. وإذا لم يوافق العضو على الشروط المعدلة، يجوز له إنهاء اتفاقية الخدمة.',
    ],
  },
  {
    title: 'المادة 4 (تسجيل العضوية والحسابات)',
    items: [
      'يكتمل تسجيل العضوية عندما يقدم المستخدم المعلومات التي تطلبها الشركة، ويوافق على الشروط والسياسات المطلوبة، وتوافق الشركة على التسجيل.',
      'يجوز للشركة رفض التسجيل أو إنهاء اتفاقية الخدمة لاحقا إذا تم تقديم معلومات كاذبة، أو استخدام اسم شخص آخر، أو كان لدى المستخدم سجل سابق لتقييد الخدمة، أو إذا كان التسجيل قد يعيق تشغيل الخدمة أو التقنية.',
      'يجب على الأعضاء الحفاظ على دقة معلومات الحساب، ويتحمل الأعضاء مسؤولية إدارة حساباتهم وكلمات المرور.',
      'قد تختلف الصلاحيات والانتماء ونطاق الاستخدام للحسابات المدعوة أو المنشأة من قبل عضو مؤسسي وفقا لاتفاقية العضو المؤسسي وسياسة إدارته.',
    ],
  },
  {
    title: 'المادة 5 (تقديم الخدمة)',
    items: [
      'تقدم الشركة الخدمات التالية: 1) محتوى محاكاة بالواقع الافتراضي والهاتف المحمول للتعليم الطبي؛ 2) إدارة الصفوف والمناهج والمشاركين وسجلات التدريب ونتائج التقييم؛ 3) إدارة المؤسسات والمستخدمين والتراخيص والمعدات والطلبات والمدفوعات؛ 4) ميزات دعم تعليمية وتشغيلية مثل السيناريوهات والموارد والمدونات واستفسارات العملاء؛ و5) خدمات إضافية أخرى تحددها الشركة.',
      'قد تختلف ميزات الخدمة التفصيلية، والمحتوى المتاح، وطريقة التقديم، والأجهزة المدعومة، والصلاحيات حسب نوع العضو، واتفاقية المؤسسة، والمنتج المطلوب، وحالة الترخيص.',
      'يجوز للشركة تغيير الخدمة كلها أو جزءا منها عند الحاجة لتحسين جودة الخدمة، أو الأمن، أو تغييرات السياسات، أو تغييرات نطاق الاتفاقية، أو الاحتياجات التشغيلية.',
    ],
  },
  {
    title: 'المادة 6 (الخدمات المدفوعة والطلبات والمدفوعات)',
    items: [
      'تتبع أسعار الخدمات المدفوعة، وفترات الاستخدام، ونطاق التقديم، وطرق الدفع، وشروط إصدار الفاتورة الضريبية أو الإيصال شاشة الطلب أو عرض السعر أو الاتفاقية أو الإشعار المنفصل.',
      'قبل الدفع، يجب على العضو أو العضو المؤسسي مراجعة تفاصيل الطلب مثل اسم المنتج، وفترة الاستخدام، والكمية، والمبلغ، وشروط الاسترداد.',
      'عند إتمام الدفع، تمنح الشركة الوصول إلى التراخيص أو الصفوف أو المحتوى أو المعدات وفقا لشروط الطلب أو الاتفاقية ذات الصلة.',
      'إذا حدث خطأ في الدفع أو فشل في الموافقة أو عدم تطابق في معلومات الطلب، يجوز للشركة تعليق الطلب أو إلغاؤه.',
    ],
  },
  {
    title: 'المادة 7 (الانسحاب والإلغاء والاسترداد)',
    items: [
      'بالنسبة للمحتوى الرقمي أو الخدمات عبر الإنترنت، قد يكون الانسحاب أو الاسترداد مقيدا ضمن النطاق الذي تسمح به القوانين المعمول بها إذا بدأ تقديم الخدمة أو بدأ الاستخدام من خلال عرض المحتوى أو تنزيله أو المشاركة في التدريب أو تفعيل الترخيص أو إجراءات مماثلة من قبل العضو.',
      'يتبع إلغاء واسترداد الصفوف المدفوعة أو الصفوف المفتوحة صفحة تفاصيل كل منتج أو شاشة الطلب أو الاتفاقية أو سياسة استرداد منفصلة.',
      'إذا لم يتم تقديم الخدمة بشكل صحيح لأسباب تعود إلى الشركة، ستتخذ الشركة تدابير معقولة مثل إعادة التقديم أو تمديد فترة الاستخدام أو الاسترداد.',
      'عند معالجة الاسترداد، قد يستغرق إتمام الاسترداد الفعلي وقتا حسب سياسات طريقة الدفع وبوابة الدفع والمؤسسة المالية.',
    ],
  },
  {
    title: 'المادة 8 (التزامات العضو)',
    paragraphs: ['يجب على الأعضاء عدم القيام بأي من الأفعال التالية:'],
    items: [
      'استخدام حساب شخص آخر أو معلوماته الشخصية أو طريقة دفعه دون إذن.',
      'تسجيل معلومات كاذبة، أو الوصول إلى مؤسسات أو صفوف دون إذن، أو إساءة استخدام روابط الدعوة.',
      'نسخ المحتوى أو توزيعه أو نقله أو بيعه أو إعارته أو مشاركته أو استخدامه خارج الخدمة دون إذن.',
      'التدخل في أمن الخدمة أو المصادقة أو الفوترة أو إدارة الصلاحيات أو التشغيل الطبيعي للخدمة.',
      'تزوير أو تغيير أو إنشاء نتائج تدريب أو بيانات تقييم أو معلومات طلب أو معلومات مماثلة بوسائل غير مناسبة.',
      'انتهاك القوانين المعمول بها أو هذه الشروط أو إشعارات الشركة أو سياسة استخدام العضو المؤسسي.',
    ],
  },
  {
    title: 'المادة 9 (مسؤوليات الأعضاء المؤسسيين والمسؤولين)',
    items: [
      'يجب على الأعضاء المؤسسيين والمسؤولين إدارة الصلاحيات والدعوات والانسحاب وتعيينات الصفوف واستخدام التراخيص والتعامل مع المعلومات الشخصية للأعضاء التابعين بما يتوافق مع القوانين المعمول بها والسياسات الداخلية.',
      'يجب على الأعضاء المؤسسيين إرشاد الأعضاء التابعين إلى استخدام الخدمة لأغراض تعليمية والتعاون حتى لا ينتهك الأعضاء التابعون الاتفاقية أو هذه الشروط.',
      'عند انتهاء اتفاقية العضو المؤسسي، أو انتهاء صلاحية الترخيص، أو إلغاء صلاحية المسؤول، قد يتم تقييد نطاق الخدمة المتاح للأعضاء التابعين.',
    ],
  },
  {
    title: 'المادة 10 (المحتوى وحقوق الملكية الفكرية)',
    items: [
      'تعود حقوق النشر والعلامات التجارية وبراءات الاختراع والأسرار التجارية وغيرها من حقوق الملكية الفكرية المتعلقة بالخدمة والمحتوى إلى الشركة أو أصحاب الحقوق الشرعيين.',
      'يجوز للأعضاء عرض المحتوى واستخدامه ضمن غرض استخدام الخدمة، ولا يجوز لهم نسخ المحتوى أو تعديله أو إنشاء أعمال مشتقة منه أو توزيعه أو نقله أو بيعه أو إعارته أو عرضه علنا أو استخدامه كمواد تعليمية خارجية دون موافقة كتابية مسبقة من الشركة.',
      'تعود الحقوق في المواد التي يرفعها أو يدخلها الأعضاء أو الأعضاء المؤسسيون في الخدمة إلى أصحاب الحقوق الأصليين. ومع ذلك، يجوز للشركة استخدام هذه المواد بالقدر اللازم لتقديم الخدمة وتشغيلها وأمنها والاستجابة للحوادث وتحسين الجودة والتحليل الإحصائي.',
    ],
  },
  {
    title: 'المادة 11 (نتائج التدريب والبيانات)',
    items: [
      'قد تتم معالجة البيانات التي تنشأ أثناء استخدام الخدمة، مثل سجلات التدريب ونتائج التقييم وسجل التعلم، لدعم تعلم العضو وتشغيل المؤسسات وتحسين جودة الخدمة وتنفيذ الاتفاقيات.',
      'يجوز للأعضاء المؤسسيين عرض وإدارة نتائج التدريب وسجل التعلم للأعضاء التابعين ضمن نطاق الاتفاقية والصلاحيات.',
      'تتبع الشركة سياسة الخصوصية عند معالجة البيانات التي تحتوي على معلومات شخصية.',
    ],
  },
  {
    title: 'المادة 12 (تعليق الخدمة)',
    items: [
      'يجوز للشركة تعليق الخدمة كلها أو جزءا منها مؤقتا إذا ظهرت أسباب لا يمكن تجنبها، مثل فحص المرافق، أو الاستجابة للحوادث، أو تدابير الأمن، أو تحسين الخدمة، أو فشل شبكة الاتصالات أو السحابة، أو أحداث القوة القاهرة.',
      'في حالة الصيانة المجدولة، ستبذل الشركة الجهود لتقديم إشعار مسبق. ومع ذلك، إذا كان تقديم الإشعار المسبق صعبا بسبب أعطال عاجلة أو تهديدات أمنية أو أسباب مماثلة، يجوز للشركة الإخطار لاحقا.',
    ],
  },
  {
    title: 'المادة 13 (قيود الاستخدام والإنهاء)',
    items: [
      'إذا انتهك العضو هذه الشروط أو السياسات ذات الصلة، يجوز للشركة اتخاذ التدابير اللازمة مثل التحذير أو التعليق أو إلغاء الصلاحيات أو تقييد الوصول إلى المحتوى أو إنهاء الحساب.',
      'يجوز للأعضاء طلب الانسحاب في أي وقت من خلال ميزات الخدمة أو مركز العملاء. ومع ذلك، قد يتم الاحتفاظ بالمعلومات المتعلقة بالطلبات الجارية أو المدفوعات أو التسوية أو الالتزامات القانونية بالاحتفاظ بها للفترة المطلوبة.',
      'قد يتم تقييد الحسابات المنشأة بموجب اتفاقية عضو مؤسسي بناء على طلب العضو المؤسسي أو عند انتهاء الاتفاقية.',
    ],
  },
  {
    title: 'المادة 14 (استخدام المعدات)',
    items: [
      'بالنسبة للمنتجات التي تشمل تأجير أو توفير معدات مثل أجهزة الواقع الافتراضي، فإن فترة التأجير، والتسليم، والإرجاع، والمسؤولية عن الفقد أو التلف، وتحمل التكاليف تتبع دليل المنتج أو الاتفاقية أو سياسة استخدام المعدات المنفصلة.',
      'يجب على الأعضاء استخدام المعدات بعناية المدير الحريص، ولا يجوز لهم نقلها أو إعارتها أو تقديمها كضمان أو استخدامها لأغراض غير مصرح بها دون إذن.',
    ],
  },
  {
    title: 'المادة 15 (تحديد المسؤولية)',
    items: [
      'لا تتحمل الشركة المسؤولية إذا لم تتمكن من تقديم الخدمة لأسباب خارجة عن سيطرتها المعقولة، مثل القوة القاهرة، أو أعطال شبكة الاتصالات، أو فشل السحابة أو خدمات الطرف الثالث، أو أسباب تعود إلى الأعضاء.',
      'لا تتحمل الشركة المسؤولية عن دقة أو قانونية أو موثوقية المعلومات التي يدخلها الأعضاء أو الأعضاء المؤسسيون في الخدمة.',
      'الخدمة مخصصة للتعليم والتدريب الطبي ولا تحل محل رعاية المرضى الفعلية أو الحكم الطبي.',
    ],
  },
  {
    title: 'المادة 16 (الأضرار)',
    paragraphs: [
      'إذا انتهكت الشركة أو العضو هذه الشروط وتسبب ذلك في ضرر للطرف الآخر، يجب على الطرف المسؤول تعويض الأضرار وفقا للقوانين المعمول بها.',
    ],
  },
  {
    title: 'المادة 17 (القانون الحاكم والاختصاص القضائي)',
    paragraphs: [
      'تفسر هذه الشروط بموجب قوانين جمهورية كوريا. وإذا نشأ نزاع فيما يتعلق باستخدام الخدمة، تكون المحكمة المختصة هي المحكمة المحددة بموجب قانون الإجراءات المدنية والقوانين المعمول بها الأخرى.',
    ],
  },
  {
    title: 'المادة 18 (الاستفسارات)',
    paragraphs: [
      'يمكن إجراء الاستفسارات المتعلقة بالخدمة وهذه الشروط من خلال معلومات الاتصال أدناه.',
      'اسم الشركة: NEWBASE Co., Ltd.',
      'البريد الإلكتروني: contact@newbase.kr',
      'الهاتف: +82-2-564-8853',
    ],
  },
];

export const TERMS_SECTIONS_ID: LegalTextSection[] = [
  {
    title: 'Pasal 1 (Tujuan)',
    paragraphs: [
      'Ketentuan ini menetapkan syarat dan prosedur penggunaan situs web Medicrew, aplikasi seluler, simulasi medis berbasis VR, konten pendidikan, pengelolaan kelas dan kurikulum, pengelolaan hasil praktik, layanan pemesanan dan pembayaran, serta layanan tambahan terkait (secara bersama-sama disebut "Layanan") yang dioperasikan oleh NEWBASE Co., Ltd. ("Perusahaan"), termasuk hak, kewajiban, dan tanggung jawab Perusahaan dan anggota.',
    ],
  },
  {
    title: 'Pasal 2 (Definisi)',
    items: [
      '"Anggota" berarti orang yang menyetujui Ketentuan ini dan menggunakan Layanan dengan membuat akun sesuai prosedur yang ditetapkan Perusahaan atau dengan diundang melalui suatu institusi.',
      '"Anggota Institusi" berarti badan hukum atau organisasi, seperti rumah sakit, sekolah, lembaga pendidikan, atau perusahaan, yang menyediakan Layanan kepada anggotanya melalui perjanjian layanan atau pesanan.',
      '"Administrator" atau "Master" berarti anggota yang diberi wewenang oleh Anggota Institusi untuk mengelola anggota terafiliasi, kelas, lisensi, konten, hasil praktik, dan hal serupa.',
      '"Peserta Didik" berarti anggota yang menggunakan fitur pendidikan seperti partisipasi kelas, praktik simulasi, melihat konten, dan meninjau hasil praktik.',
      '"Konten" berarti simulasi VR dan seluler, skenario, gambar, video, audio, pertanyaan, kriteria evaluasi, dokumen, data, dan materi digital lain yang disediakan oleh Perusahaan atau tersedia dalam Layanan.',
      '"Layanan Berbayar" berarti setiap layanan yang disediakan Perusahaan dengan biaya, termasuk langganan, lisensi, open class, kelas institusi, peralatan, atau layanan tambahan.',
    ],
  },
  {
    title: 'Pasal 3 (Pemasangan dan Perubahan Ketentuan)',
    items: [
      'Perusahaan memasang Ketentuan ini pada layar Layanan atau layar tertaut agar anggota dapat meninjaunya dengan mudah.',
      'Perusahaan dapat mengubah Ketentuan ini sepanjang perubahan tersebut tidak melanggar hukum yang berlaku.',
      'Jika Perusahaan mengubah Ketentuan ini, Perusahaan akan mengumumkan tanggal berlaku dan alasan utama perubahan sejak 7 hari sebelum tanggal berlaku. Perubahan yang merugikan atau material bagi anggota akan diumumkan sejak 30 hari sebelum tanggal berlaku atau diberitahukan melalui cara yang wajar seperti email atau notifikasi Layanan.',
      'Jika anggota terus menggunakan Layanan setelah tanggal berlaku Ketentuan yang diubah, anggota dianggap telah menyetujui Ketentuan yang diubah. Jika anggota tidak menyetujui Ketentuan yang diubah, anggota dapat mengakhiri perjanjian layanan.',
    ],
  },
  {
    title: 'Pasal 4 (Pendaftaran Keanggotaan dan Akun)',
    items: [
      'Pendaftaran keanggotaan selesai ketika pengguna memberikan informasi yang diminta Perusahaan, menyetujui Ketentuan dan kebijakan wajib, dan Perusahaan menyetujui pendaftaran.',
      'Perusahaan dapat menolak pendaftaran atau mengakhiri perjanjian layanan kemudian jika informasi palsu diberikan, nama orang lain digunakan, pengguna memiliki riwayat pembatasan layanan, atau pendaftaran dapat mengganggu operasi atau teknologi Layanan.',
      'Anggota harus menjaga agar informasi akun tetap akurat, dan anggota bertanggung jawab atas pengelolaan akun dan kata sandinya.',
      'Izin, afiliasi, dan ruang lingkup penggunaan akun yang diundang atau dibuat oleh Anggota Institusi dapat berbeda sesuai perjanjian dan kebijakan pengelolaan Anggota Institusi.',
    ],
  },
  {
    title: 'Pasal 5 (Penyediaan Layanan)',
    items: [
      'Perusahaan menyediakan layanan berikut: 1) konten simulasi VR dan seluler untuk pendidikan medis; 2) pengelolaan kelas, kurikulum, peserta, catatan praktik, dan hasil evaluasi; 3) pengelolaan institusi, pengguna, lisensi, peralatan, pesanan, dan pembayaran; 4) fitur dukungan pendidikan dan operasional seperti skenario, sumber daya, blog, dan pertanyaan pelanggan; dan 5) layanan tambahan lain yang ditentukan Perusahaan.',
      'Fitur Layanan secara rinci, konten yang tersedia, metode penyediaan, perangkat yang didukung, dan izin dapat berbeda tergantung jenis anggota, perjanjian institusi, produk yang dipesan, dan status lisensi.',
      'Perusahaan dapat mengubah seluruh atau sebagian Layanan sebagaimana diperlukan untuk peningkatan kualitas Layanan, keamanan, perubahan kebijakan, perubahan ruang lingkup perjanjian, atau kebutuhan operasional.',
    ],
  },
  {
    title: 'Pasal 6 (Layanan Berbayar, Pesanan, dan Pembayaran)',
    items: [
      'Harga, periode penggunaan, ruang lingkup penyediaan, metode pembayaran, dan ketentuan penerbitan faktur pajak atau tanda terima untuk Layanan Berbayar mengikuti layar pesanan, penawaran, perjanjian, atau pemberitahuan terpisah.',
      'Sebelum pembayaran, anggota atau Anggota Institusi harus meninjau detail pesanan seperti nama produk, periode penggunaan, jumlah, nominal, dan ketentuan pengembalian dana.',
      'Setelah pembayaran selesai, Perusahaan memberikan akses ke lisensi, kelas, konten, atau peralatan sesuai ketentuan pesanan atau perjanjian yang berlaku.',
      'Jika terjadi kesalahan pembayaran, kegagalan persetujuan, atau ketidaksesuaian informasi pesanan, Perusahaan dapat menahan atau membatalkan pesanan.',
    ],
  },
  {
    title: 'Pasal 7 (Penarikan, Pembatalan, dan Pengembalian Dana)',
    items: [
      'Untuk konten digital atau layanan daring, penarikan atau pengembalian dana dapat dibatasi dalam ruang lingkup yang diizinkan hukum yang berlaku jika penyediaan telah dimulai atau penggunaan telah dimulai melalui melihat konten, mengunduh, partisipasi praktik, aktivasi lisensi, atau tindakan serupa oleh anggota.',
      'Pembatalan dan pengembalian dana untuk kelas berbayar atau open class mengikuti halaman detail setiap produk, layar pesanan, perjanjian, atau kebijakan pengembalian dana terpisah.',
      'Jika Layanan tidak diberikan dengan benar karena alasan yang dapat dikaitkan dengan Perusahaan, Perusahaan akan mengambil tindakan yang wajar seperti penyediaan ulang, perpanjangan periode penggunaan, atau pengembalian dana.',
      'Saat pengembalian dana diproses, penyelesaian pengembalian dana sebenarnya dapat memerlukan waktu tergantung kebijakan metode pembayaran, payment gateway, dan lembaga keuangan.',
    ],
  },
  {
    title: 'Pasal 8 (Kewajiban Anggota)',
    paragraphs: ['Anggota tidak boleh melakukan tindakan berikut:'],
    items: [
      'Menggunakan akun, informasi pribadi, atau metode pembayaran orang lain tanpa izin.',
      'Mendaftarkan informasi palsu, mengakses institusi atau kelas tanpa izin, atau menyalahgunakan tautan undangan.',
      'Menyalin, mendistribusikan, mengirimkan, menjual, meminjamkan, membagikan, atau menggunakan Konten di luar Layanan tanpa izin.',
      'Mengganggu keamanan, autentikasi, penagihan, pengelolaan izin, atau operasi normal Layanan.',
      'Memalsukan, mengubah, atau membuat hasil praktik, data evaluasi, informasi pesanan, atau informasi serupa dengan cara yang tidak semestinya.',
      'Melanggar hukum yang berlaku, Ketentuan ini, pemberitahuan Perusahaan, atau kebijakan penggunaan Anggota Institusi.',
    ],
  },
  {
    title: 'Pasal 9 (Tanggung Jawab Anggota Institusi dan Administrator)',
    items: [
      'Anggota Institusi dan administrator harus mengelola izin, undangan, penarikan, penugasan kelas, penggunaan lisensi, dan penanganan informasi pribadi anggota terafiliasi sesuai hukum yang berlaku dan kebijakan internal.',
      'Anggota Institusi harus membimbing anggota terafiliasi untuk menggunakan Layanan untuk tujuan pendidikan dan bekerja sama agar anggota terafiliasi tidak melanggar perjanjian atau Ketentuan ini.',
      'Ketika perjanjian Anggota Institusi berakhir, lisensi kedaluwarsa, atau kewenangan administrator dicabut, ruang lingkup Layanan yang tersedia bagi anggota terafiliasi dapat dibatasi.',
    ],
  },
  {
    title: 'Pasal 10 (Konten dan Hak Kekayaan Intelektual)',
    items: [
      'Hak cipta, merek dagang, paten, rahasia dagang, dan hak kekayaan intelektual lain terkait Layanan dan Konten dimiliki oleh Perusahaan atau pemegang hak yang sah.',
      'Anggota dapat melihat dan menggunakan Konten dalam tujuan penggunaan Layanan dan tidak boleh menyalin, mengubah, membuat karya turunan dari, mendistribusikan, mengirimkan, menjual, meminjamkan, mempertunjukkan secara publik, atau menggunakan Konten sebagai materi pendidikan eksternal tanpa persetujuan tertulis sebelumnya dari Perusahaan.',
      'Hak atas materi yang diunggah atau dimasukkan ke Layanan oleh anggota atau Anggota Institusi dimiliki oleh pemegang hak asli. Namun, Perusahaan dapat menggunakan materi tersebut sejauh diperlukan untuk penyediaan Layanan, operasi, keamanan, respons insiden, peningkatan kualitas, dan analisis statistik.',
    ],
  },
  {
    title: 'Pasal 11 (Hasil Praktik dan Data)',
    items: [
      'Data yang dihasilkan selama penggunaan Layanan, seperti catatan praktik, hasil evaluasi, dan riwayat pembelajaran, dapat diproses untuk mendukung pembelajaran anggota, mengoperasikan institusi, meningkatkan kualitas Layanan, dan melaksanakan perjanjian.',
      'Anggota Institusi dapat melihat dan mengelola hasil praktik dan riwayat pembelajaran anggota terafiliasi dalam ruang lingkup perjanjian dan izin.',
      'Perusahaan mengikuti Kebijakan Privasi untuk memproses data yang berisi informasi pribadi.',
    ],
  },
  {
    title: 'Pasal 12 (Penghentian Sementara Layanan)',
    items: [
      'Perusahaan dapat menghentikan sementara seluruh atau sebagian Layanan jika muncul alasan yang tidak dapat dihindari, seperti pemeriksaan fasilitas, respons insiden, tindakan keamanan, peningkatan Layanan, kegagalan jaringan komunikasi atau cloud, atau peristiwa force majeure.',
      'Untuk pemeliharaan terjadwal, Perusahaan akan berupaya memberikan pemberitahuan sebelumnya. Namun, jika pemberitahuan sebelumnya sulit dilakukan karena kegagalan mendesak, ancaman keamanan, atau alasan serupa, Perusahaan dapat memberitahukan setelahnya.',
    ],
  },
  {
    title: 'Pasal 13 (Pembatasan Penggunaan dan Pengakhiran)',
    items: [
      'Jika anggota melanggar Ketentuan ini atau kebijakan terkait, Perusahaan dapat mengambil tindakan yang diperlukan seperti peringatan, penangguhan, pencabutan izin, pembatasan akses konten, atau pengakhiran akun.',
      'Anggota dapat meminta penarikan kapan saja melalui fitur Layanan atau pusat pelanggan. Namun, informasi terkait pesanan berjalan, pembayaran, penyelesaian, atau kewajiban penyimpanan hukum dapat disimpan selama periode yang diwajibkan.',
      'Akun yang dibuat berdasarkan perjanjian Anggota Institusi dapat dibatasi atas permintaan Anggota Institusi atau pada saat pengakhiran perjanjian.',
    ],
  },
  {
    title: 'Pasal 14 (Penggunaan Peralatan)',
    items: [
      'Untuk produk yang mencakup penyewaan atau penyediaan peralatan seperti perangkat VR, periode sewa, pengiriman, pengembalian, tanggung jawab atas kehilangan atau kerusakan, dan beban biaya mengikuti panduan produk, perjanjian, atau kebijakan penggunaan peralatan terpisah.',
      'Anggota harus menggunakan peralatan dengan kehati-hatian pengelola yang baik dan tidak boleh mengalihkan, meminjamkan, menjaminkan, atau menggunakannya untuk tujuan yang tidak diizinkan tanpa izin.',
    ],
  },
  {
    title: 'Pasal 15 (Pembatasan Tanggung Jawab)',
    items: [
      'Perusahaan tidak bertanggung jawab jika tidak dapat menyediakan Layanan karena alasan di luar kendali wajar Perusahaan, seperti force majeure, kegagalan jaringan komunikasi, kegagalan cloud atau layanan pihak ketiga, atau alasan yang dapat dikaitkan dengan anggota.',
      'Perusahaan tidak bertanggung jawab atas keakuratan, legalitas, atau keandalan informasi yang dimasukkan ke Layanan oleh anggota atau Anggota Institusi.',
      'Layanan ditujukan untuk pendidikan dan pelatihan medis dan tidak menggantikan perawatan pasien nyata atau pertimbangan medis.',
    ],
  },
  {
    title: 'Pasal 16 (Ganti Rugi)',
    paragraphs: [
      'Jika Perusahaan atau anggota melanggar Ketentuan ini dan menyebabkan kerugian kepada pihak lain, pihak yang bertanggung jawab harus mengganti kerugian sesuai hukum yang berlaku.',
    ],
  },
  {
    title: 'Pasal 17 (Hukum yang Berlaku dan Yurisdiksi)',
    paragraphs: [
      'Ketentuan ini ditafsirkan berdasarkan hukum Republik Korea. Jika terjadi sengketa terkait penggunaan Layanan, pengadilan yang berwenang adalah pengadilan yang ditentukan berdasarkan Undang-Undang Acara Perdata dan hukum lain yang berlaku.',
    ],
  },
  {
    title: 'Pasal 18 (Pertanyaan)',
    paragraphs: [
      'Pertanyaan mengenai Layanan dan Ketentuan ini dapat diajukan melalui informasi kontak di bawah ini.',
      'Nama perusahaan: NEWBASE Co., Ltd.',
      'Email: contact@newbase.kr',
      'Telepon: +82-2-564-8853',
    ],
  },
];

export const TERMS_SECTIONS_MN: LegalTextSection[] = [
  {
    title: '1-р зүйл (Зорилго)',
    paragraphs: [
      'Эдгээр нөхцөл нь NEWBASE Co., Ltd. ("Компани")-ийн ажиллуулдаг Medicrew вэбсайт, гар утасны аппликейшн, VR-д суурилсан эмнэлгийн симуляци, боловсролын контент, анги ба хөтөлбөрийн удирдлага, дадлагын үр дүнгийн удирдлага, захиалга ба төлбөрийн үйлчилгээ, түүнтэй холбоотой нэмэлт үйлчилгээг (хамтад нь "Үйлчилгээ") ашиглах нөхцөл, журмыг, мөн Компани болон гишүүдийн эрх, үүрэг, хариуцлагыг тогтооно.',
    ],
  },
  {
    title: '2-р зүйл (Тодорхойлолт)',
    items: [
      '"Гишүүн" гэж эдгээр нөхцөлийг зөвшөөрч, Компанийн тогтоосон журмын дагуу данс үүсгэх эсвэл байгууллагаар дамжуулан уригдах замаар Үйлчилгээг ашиглаж буй хүнийг хэлнэ.',
      '"Байгууллагын гишүүн" гэж эмнэлэг, сургууль, боловсролын байгууллага, компани зэрэг үйлчилгээний гэрээ эсвэл захиалгаар өөрийн гишүүдэд Үйлчилгээг үзүүлдэг хуулийн этгээд эсвэл байгууллагыг хэлнэ.',
      '"Администратор" эсвэл "Мастер" гэж харьяа гишүүд, анги, лиценз, контент, дадлагын үр дүн зэрэг зүйлсийг удирдах эрхийг Байгууллагын гишүүнээс авсан гишүүнийг хэлнэ.',
      '"Суралцагч" гэж ангидаа оролцох, симуляцийн дадлага хийх, контент үзэх, дадлагын үр дүнг шалгах зэрэг боловсролын боломжуудыг ашигладаг гишүүнийг хэлнэ.',
      '"Контент" гэж Компаниас үзүүлсэн эсвэл Үйлчилгээний дотор ашиглах боломжтой VR болон гар утасны симуляци, сценар, зураг, видео, аудио, асуулт, үнэлгээний шалгуур, баримт бичиг, өгөгдөл болон бусад дижитал материалыг хэлнэ.',
      '"Төлбөртэй үйлчилгээ" гэж захиалга, лиценз, open class, байгууллагын анги, тоног төхөөрөмж эсвэл нэмэлт үйлчилгээ зэрэг Компанийн төлбөртэйгээр үзүүлдэг аливаа үйлчилгээг хэлнэ.',
    ],
  },
  {
    title: '3-р зүйл (Нөхцөлийг нийтлэх ба өөрчлөх)',
    items: [
      'Компани эдгээр нөхцөлийг гишүүд хялбар шалгах боломжтой байхаар Үйлчилгээний дэлгэц эсвэл холбоос бүхий дэлгэц дээр нийтэлнэ.',
      'Компани холбогдох хууль тогтоомжийг зөрчихгүй хэмжээнд эдгээр нөхцөлийг өөрчилж болно.',
      'Компани эдгээр нөхцөлийг өөрчлөх бол хүчин төгөлдөр болох огноо болон өөрчлөлтийн гол шалтгааныг хүчин төгөлдөр болохоос 7 хоногийн өмнөөс зарлана. Гишүүдэд таагүй эсвэл чухал өөрчлөлтийг 30 хоногийн өмнөөс зарлах эсвэл email, Үйлчилгээний мэдэгдэл зэрэг зохистой аргаар мэдэгдэнэ.',
      'Гишүүн өөрчлөгдсөн нөхцөл хүчин төгөлдөр болсон өдрөөс хойш Үйлчилгээг үргэлжлүүлэн ашиглавал өөрчлөгдсөн нөхцөлийг зөвшөөрсөнд тооцно. Хэрэв гишүүн өөрчлөгдсөн нөхцөлийг зөвшөөрөхгүй бол үйлчилгээний гэрээг цуцалж болно.',
    ],
  },
  {
    title: '4-р зүйл (Гишүүнчлэлийн бүртгэл ба данс)',
    items: [
      'Хэрэглэгч Компанийн шаардсан мэдээллийг өгч, Нөхцөл болон шаардлагатай бодлогыг зөвшөөрч, Компани бүртгэлийг зөвшөөрснөөр гишүүнчлэлийн бүртгэл дуусна.',
      'Хуурамч мэдээлэл өгсөн, бусдын нэр ашигласан, өмнө нь үйлчилгээний хязгаарлалттай байсан, эсвэл бүртгэл нь Үйлчилгээний ажиллагаа эсвэл технологид саад учруулж болзошгүй бол Компани бүртгэлээс татгалзах эсвэл дараа нь үйлчилгээний гэрээг цуцалж болно.',
      'Гишүүд дансны мэдээллийг үнэн зөв байлгах ёстой бөгөөд данс, нууц үгээ удирдах хариуцлагыг гишүүд хүлээнэ.',
      'Байгууллагын гишүүнээс уригдсан эсвэл үүсгэсэн дансны эрх, харьяалал, ашиглах хүрээ нь тухайн Байгууллагын гишүүний гэрээ болон удирдлагын бодлогоос хамаарч өөр байж болно.',
    ],
  },
  {
    title: '5-р зүйл (Үйлчилгээ үзүүлэх)',
    items: [
      'Компани дараах үйлчилгээг үзүүлнэ: 1) эмнэлгийн боловсролын VR болон гар утасны симуляцийн контент; 2) анги, хөтөлбөр, оролцогч, дадлагын бүртгэл, үнэлгээний үр дүнгийн удирдлага; 3) байгууллага, хэрэглэгч, лиценз, тоног төхөөрөмж, захиалга, төлбөрийн удирдлага; 4) сценар, нөөц, блог, хэрэглэгчийн асуулт зэрэг боловсролын болон үйл ажиллагааны дэмжлэг; 5) Компанийн тогтоосон бусад нэмэлт үйлчилгээ.',
      'Үйлчилгээний нарийвчилсан боломж, ашиглах боломжтой контент, үзүүлэх арга, дэмжигдэх төхөөрөмж, эрх нь гишүүний төрөл, байгууллагын гэрээ, захиалсан бүтээгдэхүүн, лицензийн төлөвөөс хамаарч өөр байж болно.',
      'Компани Үйлчилгээний чанарыг сайжруулах, аюулгүй байдал, бодлогын өөрчлөлт, гэрээний хүрээний өөрчлөлт эсвэл үйл ажиллагааны хэрэгцээний улмаас Үйлчилгээг бүхэлд нь эсвэл хэсэгчлэн өөрчилж болно.',
    ],
  },
  {
    title: '6-р зүйл (Төлбөртэй үйлчилгээ, захиалга ба төлбөр)',
    items: [
      'Төлбөртэй үйлчилгээний үнэ, ашиглах хугацаа, үзүүлэх хүрээ, төлбөрийн арга, татварын нэхэмжлэх эсвэл баримт гаргах нөхцөл нь захиалгын дэлгэц, үнийн санал, гэрээ эсвэл тусдаа мэдэгдлийг дагана.',
      'Төлбөр хийхээс өмнө гишүүн эсвэл Байгууллагын гишүүн бүтээгдэхүүний нэр, ашиглах хугацаа, тоо хэмжээ, дүн, буцаан олголтын нөхцөл зэрэг захиалгын дэлгэрэнгүйг шалгах ёстой.',
      'Төлбөр дуусмагц Компани холбогдох захиалга эсвэл гэрээний нөхцөлийн дагуу лиценз, анги, контент эсвэл тоног төхөөрөмжид нэвтрэх эрх олгоно.',
      'Төлбөрийн алдаа, зөвшөөрлийн алдаа, эсвэл захиалгын мэдээллийн зөрүү гарвал Компани захиалгыг түр саатуулах эсвэл цуцалж болно.',
    ],
  },
  {
    title: '7-р зүйл (Татгалзах, цуцлах ба буцаан олголт)',
    items: [
      'Дижитал контент эсвэл онлайн үйлчилгээний хувьд үйлчилгээ эхэлсэн эсвэл гишүүн контент үзэх, татах, дадлагад оролцох, лиценз идэвхжүүлэх зэрэг үйлдлээр ашиглаж эхэлсэн бол холбогдох хууль зөвшөөрсөн хүрээнд татгалзах эсвэл буцаан олголт хязгаарлагдаж болно.',
      'Төлбөртэй анги эсвэл open class-ийн цуцлалт, буцаан олголт нь тухайн бүтээгдэхүүний дэлгэрэнгүй хуудас, захиалгын дэлгэц, гэрээ эсвэл тусдаа буцаан олголтын бодлогыг дагана.',
      'Компаниас шалтгаалсан шалтгаанаар Үйлчилгээ зохих ёсоор үзүүлэгдээгүй бол Компани дахин үзүүлэх, ашиглах хугацааг сунгах, буцаан олгох зэрэг зохистой арга хэмжээ авна.',
      'Буцаан олголт боловсруулах үед төлбөрийн арга, төлбөрийн гарц, санхүүгийн байгууллагын бодлогоос хамаарч бодит буцаан олголт дуусахад хугацаа шаардагдаж болно.',
    ],
  },
  {
    title: '8-р зүйл (Гишүүний үүрэг)',
    paragraphs: ['Гишүүд дараах үйлдлийг хийх ёсгүй:'],
    items: [
      'Бусдын данс, хувийн мэдээлэл, төлбөрийн аргыг зөвшөөрөлгүй ашиглах.',
      'Хуурамч мэдээлэл бүртгэх, зөвшөөрөлгүйгээр байгууллага эсвэл ангид хандах, урилгын холбоосыг буруугаар ашиглах.',
      'Контентыг зөвшөөрөлгүйгээр хуулбарлах, түгээх, дамжуулах, худалдах, зээлдүүлэх, хуваалцах, эсвэл Үйлчилгээнээс гадуур ашиглах.',
      'Үйлчилгээний аюулгүй байдал, баталгаажуулалт, төлбөр тооцоо, эрхийн удирдлага, эсвэл хэвийн ажиллагаанд саад учруулах.',
      'Дадлагын үр дүн, үнэлгээний өгөгдөл, захиалгын мэдээлэл зэрэг мэдээллийг зохисгүй аргаар хуурамчаар үйлдэх, өөрчлөх, үүсгэх.',
      'Холбогдох хууль, эдгээр Нөхцөл, Компанийн мэдэгдэл, эсвэл Байгууллагын гишүүний ашиглалтын бодлогыг зөрчих.',
    ],
  },
  {
    title: '9-р зүйл (Байгууллагын гишүүн ба администраторын хариуцлага)',
    items: [
      'Байгууллагын гишүүд болон администраторууд харьяа гишүүдийн эрх, урилга, гарах, ангийн хуваарилалт, лицензийн ашиглалт, хувийн мэдээлэлтэй харьцах ажиллагааг холбогдох хууль болон дотоод бодлогын дагуу удирдах ёстой.',
      'Байгууллагын гишүүд харьяа гишүүдийг Үйлчилгээг боловсролын зорилгоор ашиглахад чиглүүлж, харьяа гишүүд гэрээ эсвэл эдгээр Нөхцөлийг зөрчихгүй байхад хамтран ажиллах ёстой.',
      'Байгууллагын гишүүний гэрээ дуусах, лицензийн хугацаа дуусах, эсвэл администраторын эрх цуцлагдах үед харьяа гишүүдийн ашиглах боломжтой Үйлчилгээний хүрээ хязгаарлагдаж болно.',
    ],
  },
  {
    title: '10-р зүйл (Контент ба оюуны өмчийн эрх)',
    items: [
      'Үйлчилгээ болон Контенттой холбоотой зохиогчийн эрх, барааны тэмдэг, патент, худалдааны нууц болон бусад оюуны өмчийн эрх нь Компани эсвэл хууль ёсны эрх эзэмшигчдэд хамаарна.',
      'Гишүүд Үйлчилгээг ашиглах зорилгын хүрээнд Контентыг үзэж ашиглаж болох бөгөөд Компанийн урьдчилсан бичгээр өгсөн зөвшөөрөлгүйгээр Контентыг хуулбарлах, өөрчлөх, үүсмэл бүтээл хийх, түгээх, дамжуулах, худалдах, зээлдүүлэх, олон нийтэд үзүүлэх, эсвэл гадаад сургалтын материал болгон ашиглаж болохгүй.',
      'Гишүүд эсвэл Байгууллагын гишүүдийн Үйлчилгээнд байршуулсан эсвэл оруулсан материалын эрх нь анхны эрх эзэмшигчдэд хамаарна. Гэхдээ Компани Үйлчилгээ үзүүлэх, ажиллуулах, аюулгүй байдал, ослын хариу арга хэмжээ, чанар сайжруулах, статистик шинжилгээ хийхэд шаардлагатай хэмжээнд тухайн материалыг ашиглаж болно.',
    ],
  },
  {
    title: '11-р зүйл (Дадлагын үр дүн ба өгөгдөл)',
    items: [
      'Үйлчилгээг ашиглах явцад үүссэн дадлагын бүртгэл, үнэлгээний үр дүн, сургалтын түүх зэрэг өгөгдлийг гишүүний суралцахыг дэмжих, байгууллагыг ажиллуулах, Үйлчилгээний чанарыг сайжруулах, гэрээ биелүүлэх зорилгоор боловсруулж болно.',
      'Байгууллагын гишүүд гэрээ болон эрхийн хүрээнд харьяа гишүүдийн дадлагын үр дүн, сургалтын түүхийг үзэж удирдаж болно.',
      'Хувийн мэдээлэл агуулсан өгөгдлийг боловсруулахдаа Компани Нууцлалын бодлогыг дагана.',
    ],
  },
  {
    title: '12-р зүйл (Үйлчилгээг түр зогсоох)',
    items: [
      'Байгууламжийн шалгалт, ослын хариу арга хэмжээ, аюулгүй байдлын арга хэмжээ, Үйлчилгээний сайжруулалт, холбооны сүлжээ эсвэл cloud доголдол, давагдашгүй хүчин зүйл зэрэг зайлшгүй шалтгаан гарвал Компани Үйлчилгээг бүхэлд нь эсвэл хэсэгчлэн түр зогсоож болно.',
      'Төлөвлөсөн засвар үйлчилгээний үед Компани урьдчилан мэдэгдэхийг хичээнэ. Гэхдээ яаралтай доголдол, аюулгүй байдлын аюул зэрэг шалтгаанаар урьдчилан мэдэгдэхэд хүндрэлтэй бол Компани дараа нь мэдэгдэж болно.',
    ],
  },
  {
    title: '13-р зүйл (Ашиглалтын хязгаарлалт ба цуцлалт)',
    items: [
      'Гишүүн эдгээр Нөхцөл эсвэл холбогдох бодлогыг зөрчвөл Компани анхааруулга, түр зогсоох, эрх цуцлах, контентод хандахыг хязгаарлах, данс цуцлах зэрэг шаардлагатай арга хэмжээ авч болно.',
      'Гишүүд Үйлчилгээний боломжууд эсвэл хэрэглэгчийн төвөөр дамжуулан хүссэн үедээ гарах хүсэлт гаргаж болно. Гэхдээ үргэлжилж буй захиалга, төлбөр, тооцоо, эсвэл хуульд заасан хадгалах үүрэгтэй холбоотой мэдээллийг шаардлагатай хугацаанд хадгалж болно.',
      'Байгууллагын гишүүний гэрээний дагуу үүсгэсэн дансуудыг Байгууллагын гишүүний хүсэлтээр эсвэл гэрээ дуусах үед хязгаарлаж болно.',
    ],
  },
  {
    title: '14-р зүйл (Тоног төхөөрөмжийн ашиглалт)',
    items: [
      'VR төхөөрөмж зэрэг тоног төхөөрөмж түрээслэх эсвэл олгох бүтээгдэхүүний хувьд түрээсийн хугацаа, хүргэлт, буцаалт, алдагдал эсвэл эвдрэлд хүлээх хариуцлага, зардлын хариуцлага нь бүтээгдэхүүний заавар, гэрээ эсвэл тусдаа тоног төхөөрөмжийн ашиглалтын бодлогыг дагана.',
      'Гишүүд тоног төхөөрөмжийг анхааралтай эзэмшигчийн ёсоор ашиглах ёстой бөгөөд зөвшөөрөлгүйгээр шилжүүлэх, зээлдүүлэх, барьцаалах, эсвэл зөвшөөрөгдөөгүй зорилгоор ашиглаж болохгүй.',
    ],
  },
  {
    title: '15-р зүйл (Хариуцлагын хязгаарлалт)',
    items: [
      'Давагдашгүй хүчин зүйл, холбооны сүлжээний доголдол, cloud эсвэл гуравдагч талын үйлчилгээний доголдол, гишүүдээс шалтгаалсан шалтгаан зэрэг Компанийн зохистой хяналтаас гадуурх шалтгаанаар Үйлчилгээг үзүүлж чадахгүй бол Компани хариуцлага хүлээхгүй.',
      'Гишүүд эсвэл Байгууллагын гишүүдийн Үйлчилгээнд оруулсан мэдээллийн үнэн зөв, хууль ёсны байдал, найдвартай байдалд Компани хариуцлага хүлээхгүй.',
      'Үйлчилгээ нь эмнэлгийн боловсрол, сургалтад зориулагдсан бөгөөд бодит өвчтөнд үзүүлэх тусламж эсвэл эмнэлгийн шийдвэрийг орлохгүй.',
    ],
  },
  {
    title: '16-р зүйл (Хохирол)',
    paragraphs: [
      'Компани эсвэл гишүүн эдгээр Нөхцөлийг зөрчиж нөгөө талд хохирол учруулсан бол хариуцлагатай тал холбогдох хууль тогтоомжийн дагуу хохирлыг нөхөн төлөх ёстой.',
    ],
  },
  {
    title: '17-р зүйл (Захирах хууль ба харьяалал)',
    paragraphs: [
      'Эдгээр Нөхцөлийг Бүгд Найрамдах Солонгос Улсын хуулийн дагуу тайлбарлана. Үйлчилгээг ашиглахтай холбоотой маргаан гарвал эрх бүхий шүүх нь Иргэний хэрэг шүүхэд хянан шийдвэрлэх тухай хууль болон бусад холбогдох хуульд заасан шүүх байна.',
    ],
  },
  {
    title: '18-р зүйл (Асуулт)',
    paragraphs: [
      'Үйлчилгээ болон эдгээр Нөхцөлтэй холбоотой асуултыг доорх холбоо барих мэдээллээр гаргаж болно.',
      'Компанийн нэр: NEWBASE Co., Ltd.',
      'Email: contact@newbase.kr',
      'Утас: +82-2-564-8853',
    ],
  },
];
